export class Coins {
    code: string | undefined;
    name: string | undefined;
    title: string | undefined;
    type: string | undefined;
    lang:string | undefined;
    country:string | undefined;
    volume:number | undefined;
    change:number | undefined;
    price:number | undefined;
    buyPrice:number | undefined;
}
